import React, { useState, useEffect } from 'react'
import styles from '../style/pages/favouritesPage.module.css'
import likeIconNull from "../assets/svg/like null.svg"
import cartIcon from "../assets/svg/cart.svg"
import VideoList from 'components/VideoList'
import axios from 'axios'

const FavouritesPage = () => {
  const [videos, setVideos] = useState([])

	const [favouritesVideos, setFavoritesVideos] = useState(JSON.parse(localStorage.getItem("favouritesVideos")) ?? [])


	useEffect(() => {
    const getVideos = async () => {
      try {
        const res = await axios.get("https://rishat-tour.ru/api/videos")
        setVideos(res.data)
      } catch (error) {
        console.log(error.message)
      }
    }
    getVideos()
  }, [])


	useEffect(() => {
		localStorage.setItem('favouritesVideos', JSON.stringify(favouritesVideos))
	}, [favouritesVideos])


	const favoritesVideos = videos.filter(video => favouritesVideos.includes(video._id))
	
	if (!favouritesVideos || favouritesVideos.length === 0) {
		return (
			<div class={styles.favouritesWrapper}>
				<img src={cartIcon} alt="" />
				<p>В избранном пусто!</p>
				<div class={styles.favouritesInner}>
					<p>Добавляйте товары с помощью</p>
					<img src={likeIconNull} alt="" />
				</div>

			</div>
		)
	}
	return (
		<div className={styles.container}>
			<div className={styles.wrapperLike}>
				<div className={styles.favouritesTitle}>
					<h2>Избранные товары</h2>
				</div>
				<div className={styles.favouritesConcert}>
					<p>Концертные видео</p>
				</div>
				{
					<VideoList videos={favoritesVideos} />
				}
			</div>
		</div>
	)
}
export default FavouritesPage
